// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
import { FIELD_TYPES } from "../../../../../../constants/template-field-type";
export default {
    buttonText: {
        type: FIELD_TYPES.TEXT,
        label: "Button Text",
        translatable: true
    },
    impactTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Impact Title",
        translatable: true
    },
    slide1Title: {
        type: FIELD_TYPES.TEXT,
        label: "Slide 1 Title",
        translatable: true
    },
    slide2Title: {
        type: FIELD_TYPES.TEXT,
        label: "Slide 2 Title",
        translatable: true
    },
    slide3Title: {
        type: FIELD_TYPES.TEXT,
        label: "Slide 3 Title",
        translatable: true
    },
    slide4Title: {
        type: FIELD_TYPES.TEXT,
        label: "Slide 4 Title",
        translatable: true
    },
    slide5Title: {
        type: FIELD_TYPES.TEXT,
        label: "Slide 5 Title",
        translatable: true
    },
    tab1Image: {
        type: FIELD_TYPES.NESTED,
        label: "Tab 1 Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab2Image: {
        type: FIELD_TYPES.NESTED,
        label: "Tab 2 Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab3Image: {
        type: FIELD_TYPES.NESTED,
        label: "Tab 3 Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab4Image: {
        type: FIELD_TYPES.NESTED,
        label: "Tab 4 Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab5Image: {
        type: FIELD_TYPES.NESTED,
        label: "Tab 5 Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    sectionVisibility: {
        type: FIELD_TYPES.BOOLEAN,
        label: "Section Visibility",
        translatable: false
    }
};
